import React, { useState } from 'react';
import Reveal from '../UI/Reveal';
import SectionTitle from '../UI/SectionTitle/SectionTitle';
import classes from './About.module.scss';
import SocialLinks from '../UI/SocialLinks/SocialLinks';
import BackgroundTitle from '../UI/BackgroundTitle/BackgroundTitle';

const skills = [
  { name: 'Javascript', value: 90 },
  { name: 'React', value: 95 },
  { name: 'Html', value: 80 },
  { name: 'CSS', value: 85 },
  { name: 'Redux', value: 78 },
  { name: 'Bootstrap', value: 86 },
  { name: 'Webpack', value: 70 },
];

const About = () => {
  const [revealed, setRevealed] = useState(false);

  return (
    <div className={classes.About}>
      <BackgroundTitle parentClass={classes.About}>ABOUT</BackgroundTitle>

      <div className={[classes.Container, 'container'].join(' ')}>
        
        <Reveal onReveal={()=> setRevealed(true)}>

          <div className={classes.Head}>
            <SectionTitle>ABOUT ME</SectionTitle>
          </div>

          <div className={classes.Body}>
            <div className={[classes.Contents, classes.Left].join(' ')}>
              <h3 className={classes.Title}>Azher U.</h3>

              <p className={classes.Details}>I am a professional <span>Front-End Developer</span>. I have been working on <span>Web Development</span> for over 2 years. I am a <span>Javascript</span> specialist. I have been solving <span>Programming Problems</span> for over 3 years. I have specialized in many <span>Algorithms</span>. I can create Javascript animations and unique effects without using any third-party libraries. I make my code better <span>Optimized</span> & <span>Browser Friendly</span>. I have a strong grip on <span>React</span>.</p>

              <SocialLinks className={classes.Socials} />
            </div>
            
            <div className={[classes.Contents, classes.Right].join(' ')}>
              <h3 className={classes.Title}>Skills</h3>

              <div className={classes.Skills}>
                {skills.map((skill, i) => {
                  const classNames = [classes.Skill];
                  if (revealed) classNames.push(classes.Show);

                  return (
                    <div key={i} className={classNames.join(' ')}>
                      <p className={classes.Name}>{skill.name}</p>

                      <div className={classes.ProgressBar}>
                        <div className={classes.Bar}>
                          <span className={classes.Inner} style={{
                            transform: revealed ? `translateX(-${100 - skill.value}%)` : 'translateX(-100%)'
                          }}></span>
                        </div>

                        <p className={classes.Value}>{skill.value}%</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        
        </Reveal>

      </div>
    </div>
  );
}

export default About;